<div class="container type-grey">
    <header>
        <div class="wrap inner relative">
            <h1 class="logo">
                <a (click)="moveLoginPage()"></a>
            </h1>
            <div class="header-menu-box">
                <a class="menu-btn" (click)="moveLoginPage()">
                    {{ "common.login" | translate }}
                </a>
                <a class="menu-btn type-lang" (click)="toggleLanguage()">
                    {{ isKorean()? "한국어" : "ENGLISH" }}
                </a>
                <a class="setting-btn"></a>
            </div>
        </div>
    </header>
    <div class="wrapper">
        <section class="sign-in">
            <div class="inner wrap">
                <div class="step-info-box">
                    <div class="tit-box">
                        {{ "common.join" | translate }}
                    </div>
                    <div class="step-show-box">
                        <div class="step-box" [class.on]="nowStepCode == stepCode.TERMS">
                            <span class="step">
                                STEP 01
                            </span>
                            <span class="txt">
                                {{ "join.step.terms" | translate }}
                            </span>
                        </div>
                        <div class="step-box" [class.on]="nowStepCode == stepCode.INFO">
                            <span class="step">
                                STEP 02
                            </span>
                            <span class="txt">
                                {{ "join.step.info" | translate }}
                            </span>
                        </div>
                        <div class="step-box" [class.on]="nowStepCode == stepCode.DONE">
                            <span class="step">
                                STEP 03
                            </span>
                            <span class="txt">
                                {{ "join.step.done" | translate }}
                            </span>
                        </div>
                    </div>
                </div>
                <terms *ngIf="isVisible(stepCode.TERMS)" (cancelEvent)="cancel()" (nextEvent)="next()"></terms>
                <info *ngIf="isVisible(stepCode.INFO)" (cancelEvent)="cancel()" (nextEvent)="next($event)"></info>
                <done *ngIf="isVisible(stepCode.DONE)" [joinEmail]="joinEmail" (nextEvent)="next()"></done>
            </div>
        </section>
    </div>
    <footer>
        <div class="inner wrap relative">
            <div class="footer-logo">
                <a></a>
            </div>
            <div class="footer-menu">
                <div class="menu-box">
                    <a>
                        {{ "footer.companyInfo" | translate }}
                    </a>
                </div>
                <div class="menu-box">
                    <a>
                        {{ "footer.terms" | translate }}
                    </a>
                </div>
                <div class="menu-box">
                    <a>
                        <b>
                            {{ "footer.privacyPolicy" | translate }}
                        </b>
                    </a>
                </div>
            </div>
            <div class="footer-con">
                <div class="row">
                    <div class="item">
                        <span class="accent">
                            T.
                        </span>
                        070-8740-5534
                    </div>
                    <div class="item">
                        <span class="accent">
                            F.
                        </span>
                        070-8740-1730
                    </div>
                    <div class="item">
                        <span class="accent">
                            e-mail.
                        </span>
                        &nbsp;ceo@igis.co.kr
                    </div>
                </div>
                <div class="row type-copyright">
                    <div class="item">
                        Copyright ⓒ IGIS Co., Ltd. All Rights Reserved.
                    </div>
                </div>
            </div>
        </div>
    </footer>
</div>
